import { render, staticRenderFns } from "./MyProfileRoute.vue?vue&type=template&id=69b81669&"
import script from "./MyProfileRoute.vue?vue&type=script&lang=ts&"
export * from "./MyProfileRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports